/**
 * API Configuration - Products from www.kissariti.ma/api/ only (article table, no local fetch).
 */

const API_BASE = 'https://www.kissariti.ma/api';

export const API_CONFIG = {
  LOCAL: {
    PRODUCT_LIST: `${API_BASE}/article.php`,
    PRODUCT_ITEM: `${API_BASE}/article.php`,
    CARACTERISTIQUE_ALL: `${API_BASE}/caracteristique-all.php`,
    CARACTERISTIQUE: `${API_BASE}/caracteristique.php`,
    LIVRAISON: `${API_BASE}/livraison.php`,
    ORDER_CLIENT: `${API_BASE}/order_client.php`,
    COMMANDES: `${API_BASE}/commandes.php`,
    STATUS: `${API_BASE}/status.php`,
    PROMO_VALIDATE: `${API_BASE}/promo.php?action=validate`,
    PROMO_CODES: `${API_BASE}/promo.php?action=codes`,
    PROMO_RECORD_USAGE: `${API_BASE}/promo.php?action=record-usage`,
    CLIENT_SUBSCRIBE: `${API_BASE}/client.php`,
    UPLOAD: `${API_BASE}/upload.php`,
    UPLOAD_SLIDER: `${API_BASE}/upload.php`,
    TIKTOK_EVENTS: `${API_BASE}/tiktok_events.php`,
    ANALYTICS_TRACK: `${API_BASE}/analytics_track.php`,
    ANALYTICS_STATS: `${API_BASE}/analytics_stats.php`,
    DELIVERY_PROMO: `${API_BASE}/deliverypromo.php`,
    META_EVENTS: `${API_BASE}/meta_events.php`,
  },
  PRODUCTION: {
    PRODUCT_LIST: `${API_BASE}/article.php`,
    PRODUCT_ITEM: `${API_BASE}/article.php`,
    CARACTERISTIQUE_ALL: `${API_BASE}/caracteristique-all.php`,
    CARACTERISTIQUE: `${API_BASE}/caracteristique.php`,
    LIVRAISON: `${API_BASE}/livraison.php`,
    ORDER_CLIENT: `${API_BASE}/order_client.php`,
    COMMANDES: `${API_BASE}/commandes.php`,
    STATUS: `${API_BASE}/status.php`,
    PROMO_VALIDATE: `${API_BASE}/promo.php?action=validate`,
    PROMO_CODES: `${API_BASE}/promo.php?action=codes`,
    PROMO_RECORD_USAGE: `${API_BASE}/promo.php?action=record-usage`,
    CLIENT_SUBSCRIBE: `${API_BASE}/client.php`,
    UPLOAD: `${API_BASE}/upload.php`,
    UPLOAD_SLIDER: `${API_BASE}/upload.php`,
    TIKTOK_EVENTS: `${API_BASE}/tiktok_events.php`,
    ANALYTICS_TRACK: `${API_BASE}/analytics_track.php`,
    ANALYTICS_STATS: `${API_BASE}/analytics_stats.php`,
    DELIVERY_PROMO: `${API_BASE}/deliverypromo.php`,
    META_EVENTS: `${API_BASE}/meta_events.php`,
  },
  STAGING: {
    PRODUCT_LIST: `${API_BASE}/article.php`,
    PRODUCT_ITEM: `${API_BASE}/article.php`,
    CARACTERISTIQUE_ALL: `${API_BASE}/caracteristique-all.php`,
    CARACTERISTIQUE: `${API_BASE}/caracteristique.php`,
    LIVRAISON: `${API_BASE}/livraison.php`,
    ORDER_CLIENT: `${API_BASE}/order_client.php`,
    COMMANDES: `${API_BASE}/commandes.php`,
    STATUS: `${API_BASE}/status.php`,
    PROMO_VALIDATE: `${API_BASE}/promo.php?action=validate`,
    PROMO_CODES: `${API_BASE}/promo.php?action=codes`,
    PROMO_RECORD_USAGE: `${API_BASE}/promo.php?action=record-usage`,
    CLIENT_SUBSCRIBE: `${API_BASE}/client.php`,
    UPLOAD: `${API_BASE}/upload.php`,
    UPLOAD_SLIDER: `${API_BASE}/upload.php`,
    TIKTOK_EVENTS: `${API_BASE}/tiktok_events.php`,
    ANALYTICS_TRACK: `${API_BASE}/analytics_track.php`,
    ANALYTICS_STATS: `${API_BASE}/analytics_stats.php`,
    DELIVERY_PROMO: `${API_BASE}/deliverypromo.php`,
    META_EVENTS: `${API_BASE}/meta_events.php`,
  }
};

const CURRENT_ENV = 'PRODUCTION';
export const API_URLS = API_CONFIG[CURRENT_ENV as keyof typeof API_CONFIG];

// Always use remote API (www.kissariti.ma/api/) for products – no local or proxy fetch.
export const getApiUrl = (endpoint: keyof typeof API_URLS): string => {
  return API_URLS[endpoint];
}; 